// src/api/index.js

import axios from 'axios';
// src/api/index.js

import eventService from './eventService';
import commentService from './commentService';


// Création d'une instance axios configurée pour votre API
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://admin.propentatech.com/api/',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token d'authentification si disponible
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Service d'authentification
export const authService = {
  login: (credentials) => api.post('/auth/token/', credentials),
  refreshToken: (refreshToken) => api.post('/auth/token/refresh/', { refresh: refreshToken }),
  register: (userData) => api.post('/auth/register/', userData),
};

// Service pour les utilisateurs
export const userService = {
  getAll: (params = {}) => api.get('/users/', { params }),
  getById: (id) => api.get(`/users/${id}/`),
  create: (data) => api.post('/users/', data),
  update: (id, data) => api.put(`/users/${id}/`, data),
  delete: (id) => api.delete(`/users/${id}/`),
  getCurrentUser: () => api.get('/users/me/'),
};

// Service pour les services
export const serviceService = {
  getAll: (params = {}) => api.get('/services/', { params }),
  getById: (id) => api.get(`/services/${id}/`),
  create: (data) => api.post('/services/', data),
  update: (id, data) => api.put(`/services/${id}/`, data),
  delete: (id) => api.delete(`/services/${id}/`),
  getFeatured: () => api.get('/services/featured/'),
};

// Service pour les projets
export const projectService = {
  getAll: (params = {}) => api.get('/projects/', { params }),
  getById: (id) => api.get(`/projects/${id}/`),
  create: (data) => api.post('/projects/', data),
  update: (id, data) => api.put(`/projects/${id}/`, data),
  delete: (id) => api.delete(`/projects/${id}/`),
  apply: (id, data) => api.post(`/projects/${id}/apply/`, data),
};

// Service pour les candidatures aux projets
export const projectApplicationService = {
  getAll: (params = {}) => api.get('/project-applications/', { params }),
  getById: (id) => api.get(`/project-applications/${id}/`),
  create: (data) => api.post('/project-applications/', data),
  update: (id, data) => api.put(`/project-applications/${id}/`, data),
  delete: (id) => api.delete(`/project-applications/${id}/`),
  updateStatus: (id, statusData) => api.post(`/project-applications/${id}/update_status/`, statusData),
};

// Service pour les formations
export const formationService = {
  getAll: (params = {}) => api.get('/formations/', { params }),
  getById: (id) => api.get(`/formations/${id}/`),
  create: (data) => api.post('/formations/', data),
  update: (id, data) => api.put(`/formations/${id}/`, data),
  delete: (id) => api.delete(`/formations/${id}/`),
  register: (id, data) => api.post(`/formations/${id}/register/`, data),
};

// Service pour les inscriptions aux formations
export const formationRegistrationService = {
  getAll: (params = {}) => api.get('/formation-registrations/', { params }),
  getById: (id) => api.get(`/formation-registrations/${id}/`),
  create: (data) => api.post('/formation-registrations/', data),
  update: (id, data) => api.put(`/formation-registrations/${id}/`, data),
  delete: (id) => api.delete(`/formation-registrations/${id}/`),
  updateStatus: (id, statusData) => api.post(`/formation-registrations/${id}/update_status/`, statusData),
};

// Service pour les catégories de galerie
export const galleryCategoryService = {
  getAll: (params = {}) => api.get('/gallery-categories/', { params }),
  getById: (id) => api.get(`/gallery-categories/${id}/`),
  create: (data) => api.post('/gallery-categories/', data),
  update: (id, data) => api.put(`/gallery-categories/${id}/`, data),
  delete: (id) => api.delete(`/gallery-categories/${id}/`),
};

// Service pour les éléments de galerie
export const galleryItemService = {
  getAll: (params = {}) => api.get('/gallery-items/', { params }),
  getById: (id) => api.get(`/gallery-items/${id}/`),
  create: (data) => api.post('/gallery-items/', data),
  update: (id, data) => api.put(`/gallery-items/${id}/`, data),
  delete: (id) => api.delete(`/gallery-items/${id}/`),
  getFeatured: () => api.get('/gallery-items/featured/'),
};

// Service pour les contacts
export const contactService = {
  getAll: (params = {}) => api.get('/contacts/', { params }),
  getById: (id) => api.get(`/contacts/${id}/`),
  create: (data) => api.post('/contacts/', data),
  update: (id, data) => api.put(`/contacts/${id}/`, data),
  delete: (id) => api.delete(`/contacts/${id}/`),
  updateStatus: (id, statusData) => api.post(`/contacts/${id}/update_status/`, statusData),
};

// Service pour les solutions
export const solutionService = {
  getAll: (params = {}) => api.get('/solutions/', { params }),
  getById: (id) => api.get(`/solutions/${id}/`),
  create: (data) => api.post('/solutions/', data),
  update: (id, data) => api.put(`/solutions/${id}/`, data),
  delete: (id) => api.delete(`/solutions/${id}/`),
  getFeatured: () => api.get('/solutions/featured/'),
};

// Service pour les cas de solutions
export const solutionCaseService = {
  getAll: (params = {}) => api.get('/solution-cases/', { params }),
  getById: (id) => api.get(`/solution-cases/${id}/`),
  create: (data) => api.post('/solution-cases/', data),
  update: (id, data) => api.put(`/solution-cases/${id}/`, data),
  delete: (id) => api.delete(`/solution-cases/${id}/`),
};

// Mettez à jour votre service membershipApplicationService pour gérer FormData

// Service pour les demandes d'adhésion
export const membershipApplicationService = {
  getAll: (params = {}) => api.get('/membership-applications/', { params }),
  getById: (id) => api.get(`/membership-applications/${id}/`),
  create: (data) => {
    // Vérifier si data est une instance de FormData
    if (data instanceof FormData) {
      return api.post('/membership-applications/', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    // Sinon, envoyer comme JSON standard
    return api.post('/membership-applications/', data);
  },
  update: (id, data) => api.put(`/membership-applications/${id}/`, data),
  delete: (id) => api.delete(`/membership-applications/${id}/`),
  updateStatus: (id, statusData) => api.post(`/membership-applications/${id}/update_status/`, statusData),
};

// Service pour les catégories d'articles
export const articleCategoryService = {
  getAll: (params = {}) => api.get('/article-categories/', { params }),
  getById: (id) => api.get(`/article-categories/${id}/`),
  create: (data) => api.post('/article-categories/', data),
  update: (id, data) => api.put(`/article-categories/${id}/`, data),
  delete: (id) => api.delete(`/article-categories/${id}/`),
};

// Service pour les articles
export const articleService = {
  getAll: (params = {}) => api.get('/articles/', { params }),
  getById: (id) => api.get(`/articles/${id}/`),
  create: (data) => api.post('/articles/', data),
  update: (id, data) => api.put(`/articles/${id}/`, data),
  delete: (id) => api.delete(`/articles/${id}/`),
  getFeatured: () => api.get('/articles/featured/'),
};

// Service pour les tags
export const tagService = {
  getAll: (params = {}) => api.get('/tags/', { params }),
  getById: (id) => api.get(`/tags/${id}/`),
  create: (data) => api.post('/tags/', data),
  update: (id, data) => api.put(`/tags/${id}/`, data),
  delete: (id) => api.delete(`/tags/${id}/`),
};

// src/api/services/eventService.js
export {
  eventService,
  commentService
};

// Service pour les témoignages
export const testimonialService = {
  getAll: (params = {}) => api.get('/testimonials/', { params }),
  getById: (id) => api.get(`/testimonials/${id}/`),
  create: (data) => api.post('/testimonials/', data),
  update: (id, data) => api.put(`/testimonials/${id}/`, data),
  delete: (id) => api.delete(`/testimonials/${id}/`),
  getFeatured: () => api.get('/testimonials/featured/'),
};

// Service pour les inscriptions à la newsletter
export const newsletterService = {
  getAll: (params = {}) => api.get('/newsletters/', { params }),
  getById: (id) => api.get(`/newsletters/${id}/`),
  create: (data) => api.post('/newsletters/', data),
  update: (id, data) => api.put(`/newsletters/${id}/`, data),
  delete: (id) => api.delete(`/newsletters/${id}/`),
};

// Service pour les activités communautaires
export const communityActivityService = {
  getAll: (params = {}) => api.get('/community-activities/', { params }),
  getById: (id) => api.get(`/community-activities/${id}/`),
  create: (data) => api.post('/community-activities/', data),
  update: (id, data) => api.put(`/community-activities/${id}/`, data),
  delete: (id) => api.delete(`/community-activities/${id}/`),
  getFeatured: () => api.get('/community-activities/featured/'),
};

export default api;